import React, { useCallback, useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  useLocation,
} from "react-router-dom";
import Login from "./components/auth/login";
import Home from "./components/dashboard/dashboard";
import SignOut from "./components/auth/signout";
import MainLayout from "./components/layout/mainlayout";
import ForgotPassword from "./components/auth/forgotpassword";
import Onboardemployee from "./components/onboardemployee/onboardemployee";
import AssignAsset from "./components/onboardemployee/assignasset";
import WelcomeKit from "./components/onboardemployee/welcomekit";
import Assethandover from "./components/offboardemployee/assethandover";
import Settlement from "./components/offboardemployee/settlement";
import Offboardemployee from "./components/offboardemployee/offboardemployee";
import Registerassest from "./components/assests/registerassest";
import Profile from "./components/layout/profile";
import Assetinventory from "./components/assests/assetinventory";
import AssignAssestList from "./components/assests/assignassestlist";
import AssetMasterReport from "./components/assests/assetmasterreport";
import Submitclaims from "./components/claims/submitclaims";
import ClaimStatus from "./components/claims/claimstatus";
import SubmitTimesheet from "./components/timesheet/submittimesheet";
import ViewTimesheet from "./components/timesheet/viewtimesheet";
import ApproveTimesheet from "./components/timesheet/approvetimesheet";
import TimesheetReport from "./components/timesheet/timesheetreport";
import OnboardProjects from "./components/pmo/onboardprojects";
import AssignProject from "./components/pmo/assignproject";
import Submitleave from "./components/leaveManagement/submitleave";
import Leavereport from "./components/leaveManagement/leavereport";
import ClaimReport from "./components/claims/claimreport";
import Payslips from "./components/selfservices/payslips";
import PersonalInformation from "./components/selfservices/personalInformation";
import MedicalInsurance from "./components/selfservices/medicalInsurance";
import Exitrequest from "./components/selfservices/exitrequest";
import Profilesearch from "./components/organisation/profilesearch";
import EmployeeSeperation from "./components/onboardemployee/employeeseperation";
import UploadPolicy from "./components/organisation/uploadpolicy";
import GuestRegistartion from "./components/guestregistration/guestregistartion";
import GuestList from "./components/guestregistration/guestlist";
import Complaint from "./components/organisation/complaint";
import HrConnect from "./components/organisation/hrconnect";
import Policies from "./components/organisation/policies";
import EmployeeManagement from "./components/organisation/employeemanagement";
import EmployeeDetails from "./components/organisation/employeedetails";
import AssignedAssestlist from "./components/assests/assignedassetlist";
import Permissions from "./components/organisation/permissions";
import AdvanceSalary from "./components/selfservices/advancesalary";
import SubmitRequest from "./components/supportAndRequest/submitrequest";
import RequestStatus from "./components/supportAndRequest/requeststatus";
import RequestReport from "./components/supportAndRequest/requestreport";
import EmployeeUpdate from "./components/organisation/employeeupdate";
import { useAuth } from "../src/components/auth/authprovider";
import axios from "axios";
import UploadCenter from "./components/organisation/uploadcenter";
import LeaveStatus from "./components/leaveManagement/leavestatus";
import LeaveBalance from "./components/leaveManagement/leavebalance";
import AdminDashboard from "./components/dashboard/admindashboard";
import { toast } from "react-toastify";
import { useUser } from "./utils/userContext";
import NoAccess from "./components/auth/noAccess";
import TermsAndCondition from "./components/auth/termsandcondition";
import OcrFile from "./components/ocr/ocrfile";
import AdvanceSalaryRequests from "./components/organisation/advancesalaryrequests";
import HrList from "./components/organisation/hrlist";
import ComplaintList from "./components/organisation/complaintlist";
import Holidays from "./components/holidays/holidays";
import LeaveApproval from "./components/leaveManagement/leaveapproval";
import AnnouncementForm from "./components/announcements/announcemments";
import MasterReports from "./components/reports/masterreports";
import ProjectReport from "./components/reports/projectreport";
import OrgChart from "./components/organisation/orgchart";
import Partners from "./components/partners/Partners";
import Partnerinvoices from "./components/partners/Partnerinvoices";
import Vendors from "./components/vendor/Vendor";
import Invoices from "./components/vendor/invoices";
import UpdateWelcomeKit from "./components/onboardemployee/updatewelcomekit";
import VendorInvoicesPage from "./components/vendor/VendorInvoicesPage";
import VendorInvoicesDashboardPage from "./components/vendor/VendorInvoicesDashboardPage";
import PartnersDashboardPage from "./components/partner/PartnersDashboardPage";
import Bookticket from "./components/Traveldesk/bookticket";
import MyOrders from "./components/Traveldesk/my orders";
import Tickets from "./components/Traveldesk/tickets";
import Bookingrequests from "./components/Traveldesk/bookingrequests";
const App = () => {
  return (
    <Router>
      <AuthWrapper />
    </Router>
  );
};

const AuthWrapper = () => {
  const { fetchToken } = useAuth();
  const [userPermissions, setUserPermissions] = useState([]);
  const [userAccessLevel, setUserAccessLevel] = useState("");
  const [tokenFetched, setTokenFetched] = useState(false); // Track token fetching
  const [loading, setLoading] = useState(false);
  const [permissionsLoaded, setPermissionsLoaded] = useState(false);
  const navigate = useNavigate();
  const { user } = useUser();
  let sessionExpiredFlag = false;

  const debouncedFetchUserPermissions = useCallback(
    debounce(async () => {
      setLoading(true);
      try {
        const path = "/permissionDetails";
        const URL = process.env.REACT_APP_BE_URL + path;
        const storedToken = localStorage.getItem("token");
        const response = await axios.get(URL, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        });

        if (response.status === 200) {
          const permissions = response.data.permissions;
          setUserPermissions(permissions);
          setUserAccessLevel(user?.UserAccessLevel);
        }
      } catch (error) {
        if (axios.isAxiosError(error)) {
          if (error.response) {
            const status = error.response.status;
            console.log("status", error.response.data.Message);
            switch (status) {
              case 400:
                console.error("Bad Request:", error.response.data.Message);
                toast.error(
                  `${error.response.data.Message || "Please check your input."
                  }`,
                  {
                    position: toast.POSITION.TOP_CENTER,
                  }
                );
                // Handle specific error code 400
                break;
              case 401:
                // console.error("Unauthorized - Redirecting to login page");
                // toast.error(`${"Session Expired"}`, {
                //   position: toast.POSITION.TOP_CENTER,
                // });
                // // Redirect to login page if unauthorized
                // navigate("/");
                // break;
                if (!sessionExpiredFlag) {
                  sessionExpiredFlag = true;
                  console.error("Unauthorized - Redirecting to login page");
                  toast.error("Session Expired", {
                    position: toast.POSITION.TOP_CENTER,
                  });
                  // Redirect to login page if unauthorized
                  navigate("/");
                }
                break;
              case 404:
                console.error("Not Found:", error.response.data.Message);
                toast.error(`${error.response.data.Message || "Not Found"}`, {
                  position: toast.POSITION.TOP_CENTER,
                });
                // Handle specific error code 404
                break;
              case 500:
                console.error(
                  "Internal Server Error:",
                  error.response.data.Message
                );
                toast.error(
                  `${error.response.data.Message || "Internal Server Error"}`,
                  {
                    position: toast.POSITION.TOP_CENTER,
                  }
                );
                // Handle specific error code 500
                break;
              default:
                console.error("Unhandled Error:", error.response.data.Message);
                toast.error(
                  `${error.response.data.Message || "Unhandled Error"}`,
                  {
                    position: toast.POSITION.TOP_CENTER,
                  }
                );
                break;
            }
          } else {
            console.error("Network Error:", error.message);
          }
        } else {
          console.error("Error fetching user permissions:", error.message);
        }
      } finally {
        setLoading(false);
        setPermissionsLoaded(true);
      }
    }, 300), // 300ms debounce delay
    [fetchToken, navigate]
  );

  useEffect(() => {
    const currentPath = window.location.pathname;
    if (!tokenFetched && currentPath !== "/") {
      // Fetch permissions only if not on the login page
      debouncedFetchUserPermissions();
      setTokenFetched(true);
    }
  }, [tokenFetched, debouncedFetchUserPermissions]);

  const hasPermission = (featureName) => {
    const permission = userPermissions.find(
      (permission) => permission.featureName === featureName
    );
    if (permission && user?.UserAccessLevel) {
      const normalizedAccessLevel = user.UserAccessLevel.replace(
        /\s+/g,
        ""
      ).toLowerCase();
      for (let key in permission) {
        const normalizedKey = key.replace(/\s+/g, "").toLowerCase();
        if (
          normalizedKey === normalizedAccessLevel &&
          permission[key] === "Yes"
        ) {
          return true;
        }
      }
    }
    return false;
  };

  if (window.location.pathname === "/") {
    return <Login />;
  }

  if (loading) {
    return (
      <div>
        {loading && (
          <div id="preloading">
            <span className="loader"></span>
          </div>
        )}
      </div>
    );
  }

  if (!permissionsLoaded) {
    return null; // or a loading spinner if you prefer
  }

  // Show only Partners route for Partner userType
  if (user?.UserAccessLevel === "Partner") {
    return (
      <Routes>
        <Route
          path="/partner-dashboard"
          element={
            <MainLayout>
              <PartnersDashboardPage />
            </MainLayout>
          }
        />
        {/* Redirect any other route to /partner-dashboard */}
        <Route
          path="*"
          element={
            <MainLayout>
              <PartnersDashboardPage />
            </MainLayout>
          }
        />
      </Routes>
    );
  }

  if (user?.UserAccessLevel === "Vendor") {
    return (
      <Routes>
        <Route
          path="/vendor-invoices"
          element={
            <MainLayout>
              <VendorInvoicesPage />
            </MainLayout>
          }
        />
        <Route
          path="/vendor-invoices-dashboard"
          element={
            <MainLayout>
              <VendorInvoicesDashboardPage />
            </MainLayout>
          }
        />
        {/* Redirect any other route to /vendor-invoices */}
        <Route
          path="*"
          element={
            <MainLayout>
              <VendorInvoicesPage />
            </MainLayout>
          }
        />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route
        path="/home"
        element={
          hasPermission("Home") ? (
            <MainLayout>
              <Home />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/Dashboard"
        element={
          hasPermission("Dashboard") ? (
            <MainLayout>
              <AdminDashboard />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/signout"
        element={
          hasPermission("SignOut") ? (
            <MainLayout>
              <SignOut />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/profile"
        element={
          hasPermission("My Profile") ? (
            <MainLayout>
              <Profile />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/holidays"
        element={
          hasPermission("Holidays") ? (
            <MainLayout>
              <Holidays />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/announcements"
        element={
          hasPermission("Announcements") ? (
            <MainLayout>
              <AnnouncementForm />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route path="/forgotpassword" element={<ForgotPassword />} />
      <Route
        path="/onboardemployee"
        element={
          hasPermission("Onboard") ? (
            <MainLayout>
              <Onboardemployee />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/assignasset"
        element={
          hasPermission("Onboard") ? (
            <MainLayout>
              <AssignAsset />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/welcomekit"
        element={
          hasPermission("Onboard") ? (
            <MainLayout>
              <WelcomeKit />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/updatewelcomekit"
        element={
          hasPermission("WelcomeKit") ? (
            <MainLayout>
              <UpdateWelcomeKit />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/offboardemployee"
        element={
          hasPermission("Offboard") ? (
            <MainLayout>
              <Offboardemployee />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/assethandover"
        element={
          hasPermission("Offboard") ? (
            <MainLayout>
              <Assethandover />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/settlement"
        element={
          hasPermission("Offboard") ? (
            <MainLayout>
              <Settlement />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/RegisterAsset"
        element={
          hasPermission("Register Asset") ? (
            <MainLayout>
              <Registerassest />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/AssetInventory"
        element={
          hasPermission("Asset Inventory") ? (
            <MainLayout>
              <Assetinventory />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/AssignAssetList"
        element={
          hasPermission("Assign Asset") ? (
            <MainLayout>
              <AssignAssestList />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/AssignedAssetList"
        element={
          hasPermission("Assigned Assets") ? (
            <MainLayout>
              <AssignedAssestlist />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/AssetMasterReport"
        element={
          hasPermission("Master Report") ? (
            <MainLayout>
              <AssetMasterReport />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/SubmitClaims"
        element={
          hasPermission("Submit Claims") ? (
            <MainLayout>
              <Submitclaims />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/ClaimStatus"
        element={
          hasPermission("Claims Status") ? (
            <MainLayout>
              <ClaimStatus />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/ClaimReport"
        element={
          hasPermission("Claims Report") ? (
            <MainLayout>
              <ClaimReport />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/SubmitTimesheet"
        element={
          hasPermission("Submit Timesheet") ? (
            <MainLayout>
              <SubmitTimesheet />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/ViewTimesheet"
        element={
          hasPermission("View Timesheet") ? (
            <MainLayout>
              <ViewTimesheet />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/ApproveTimesheet"
        element={
          hasPermission("Approve Timesheet") ? (
            <MainLayout>
              <ApproveTimesheet />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/TimesheetReport"
        element={
          hasPermission("Timesheet Report") ? (
            <MainLayout>
              <TimesheetReport />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/OnboardProjects"
        element={
          hasPermission("Projects Dashboard") ? (
            <MainLayout>
              <OnboardProjects />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/AssignProjects"
        element={
          hasPermission("Assign Project") ? (
            <MainLayout>
              <AssignProject />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/SubmitLeave"
        element={
          hasPermission("Submit Leave") ? (
            <MainLayout>
              <Submitleave />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/LeaveStatus"
        element={
          hasPermission("Leave Status") ? (
            <MainLayout>
              <LeaveStatus />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/LeaveReport"
        element={
          hasPermission("Leave Report") ? (
            <MainLayout>
              <Leavereport />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/LeaveBalance"
        element={
          hasPermission("Leave Balance") ? (
            <MainLayout>
              <LeaveBalance />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/LeaveApproval"
        element={
          hasPermission("Leave Approval") ? (
            <MainLayout>
              <LeaveApproval />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/Payslips"
        element={
          hasPermission("Payslips") ? (
            <MainLayout>
              <Payslips />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/PersonalInformation"
        element={
          hasPermission("Personal Information") ? (
            <MainLayout>
              <PersonalInformation />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/MedicalInsurance"
        element={
          hasPermission("Medical Insurance") ? (
            <MainLayout>
              <MedicalInsurance />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/ExitRequest"
        element={
          hasPermission("Exit Request") ? (
            <MainLayout>
              <Exitrequest />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/ProfileSearch"
        element={
          hasPermission("Profile Search") ? (
            <MainLayout>
              <Profilesearch />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/EmployeeSeparation"
        element={
          hasPermission("Employee Separation") ? (
            <MainLayout>
              <EmployeeSeperation />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/UploadPolicy"
        element={
          hasPermission("Upload Policies") ? (
            <MainLayout>
              <UploadPolicy />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/policies"
        element={
          hasPermission("Policies") ? (
            <MainLayout>
              <Policies />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/GuestRegistartion"
        element={
          hasPermission("Register Guest") ? (
            <MainLayout>
              <GuestRegistartion />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/GuestList"
        element={
          hasPermission("View Guests") ? (
            <MainLayout>
              <GuestList />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/Complaint"
        element={
          hasPermission("Submit Complaint and Feedback") ? (
            <MainLayout>
              <Complaint />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/HrConnect"
        element={
          hasPermission("HR Connect") ? (
            <MainLayout>
              <HrConnect />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/Employees"
        element={
          hasPermission("Employees") ? (
            <MainLayout>
              <EmployeeManagement />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      {/* <Route
        path="/EmployeeDetails/:employeeId"
        element={
          hasPermission("Employees") ? (
            <MainLayout>
              <EmployeeDetails />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      /> */}
      <Route
        path="/EmployeeDetails/:employeeId"
        element={
          <MainLayout>
            <EmployeeDetails />
          </MainLayout>
        }
      />
      <Route
        path="/Permissions"
        element={
          hasPermission("Permissions") ? (
            <MainLayout>
              <Permissions />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/AdvanceSalary"
        element={
          hasPermission("Advance Salary") ? (
            <MainLayout>
              <AdvanceSalary />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/SubmitRequest"
        element={
          hasPermission("Submit Request") ? (
            <MainLayout>
              <SubmitRequest />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/RequestStatus"
        element={
          hasPermission("Request Status") ? (
            <MainLayout>
              <RequestStatus />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/RequestReport"
        element={
          hasPermission("Request Report") ? (
            <MainLayout>
              <RequestReport />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/EmployeeUpdate/:employeeId"
        element={
          hasPermission("Employees") ? (
            <MainLayout>
              <EmployeeUpdate />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/UploadCenter"
        element={
          hasPermission("Upload Center") ? (
            <MainLayout>
              <UploadCenter />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/SalaryRequests"
        element={
          hasPermission("Advance Salary Requests") ? (
            <MainLayout>
              <AdvanceSalaryRequests />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/HrList"
        element={
          hasPermission("HR List") ? (
            <MainLayout>
              <HrList />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/ComplaintList"
        element={
          hasPermission("Complaint and Feedback List") ? (
            <MainLayout>
              <ComplaintList />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/master-reports"
        element={
          hasPermission("OverAll Reports") ? (
            <MainLayout>
              <MasterReports />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/project-report"
        element={
          hasPermission("Complaint and Feedback List") ? (
            <MainLayout>
              <ProjectReport />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/org-chart"
        element={
          hasPermission("Organisation Chart") ? (
            <MainLayout>
              <OrgChart />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/bookticket"
        element={
          hasPermission("TravelDesk") ? (
            <MainLayout>
              <Bookticket />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }

      />
        <Route
        path="/My-Orders"
        element={
          hasPermission("My Orders") ? (
            <MainLayout>
              <MyOrders />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }

      />

       <Route
        path="/tickets"
        element={
          hasPermission("TravelDesk") ? (
            <MainLayout>
              <Tickets/>
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }

      />

       <Route
        path="/bookingrequests"
        element={
          hasPermission("TravelDesk") ? (
            <MainLayout>
              <Bookingrequests/>
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }

      />
      <Route
        path="/partners"
        element={
          hasPermission("Partner Management") ? (
            <MainLayout>
              <Partners />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
       <Route
        path="/partnerinvoices"
        element={
          hasPermission("Partner Management") ? (
            <MainLayout>
              <Partnerinvoices/>
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route
        path="/vendors"
        element={
          hasPermission("Organisation Chart") ? (
            <MainLayout>
              <Vendors />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
         <Route
        path="/invoices"
        element={
          hasPermission("Vendor Management") ? (
            <MainLayout>
              <Invoices />
            </MainLayout>
          ) : (
            <MainLayout>
              <NoAccess />
            </MainLayout>
          )
        }
      />
      <Route path="/TermsAndCondition" element={<TermsAndCondition />} />
      <Route
        path="/ocr"
        element={
          <MainLayout>
            <OcrFile />
          </MainLayout>
        }
      />
    </Routes>
  );
};

function debounce(func, delay) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}

export default App;
